export const initAssets = [
  'brand/anim/skeleton.json',
  'atlases/init-0.json',
]
export const splashAssets = [
  'animations/spine/freespins/back/skeleton.json',
  'animations/spine/fullscreen/skeleton.json',
  'brand/images/brand.png',
  'atlases/splash-0.json',
  'atlases/base-0.json',
]
export const assets = [
  'animations/spine/back/skeleton.json',
  'animations/spine/barker/skeleton.json',
  'animations/spine/freespins/15fs_logo/skeleton.json',
  'animations/spine/freespins/barker/skeleton.json',
  'animations/spine/freespins/reel/skeleton.json',
  'animations/spine/items/win/1/skeleton.json',
  'animations/spine/items/win/2/skeleton.json',
  'animations/spine/items/win/3/skeleton.json',
  'animations/spine/items/win/A/skeleton.json',
  'animations/spine/items/win/B/skeleton.json',
  'animations/spine/items/win/C/skeleton.json',
  'animations/spine/items/win/D/skeleton.json',
  'animations/spine/items/win/E/skeleton.json',
  'animations/spine/items/win/F/skeleton.json',
  'animations/spine/items/win/G/skeleton.json',
  'animations/spine/items/win/H/skeleton.json',
  'animations/spine/win/skeleton.json',
  'bitmap/bitmap.xml',
  'atlases/main-0.json',
]
export const particle = []
